<template>
    <div>
        <el-row class="cnt-wrapper">
            <el-col :span="4">
                <div class="dept-side">
                    <el-row class="dept-side-hd">
                        <el-col :span="12"><i class="el-icon-menu"></i>部门</el-col>
                        <el-col :span="12" class="dept-side-edit"><a>[编辑]</a></el-col>
                    </el-row>
                    <el-tree :data="branchTree" :props="defaultProps" node-key="id"
                            @node-click="handleNodeClick"></el-tree>
                </div>
            </el-col>
            <el-col :span="20">
                <div class="staff-main-content">
                    <el-tabs v-model="activeName" type="border-card">
                        <el-tab-pane label="新建部门" name="create">
                            <div>
                                <div class="staff-info">
                                    <branch-form v-if="branchTree.length > 0" :branches-tree="branchTree" @saveCallback="saveCallback"></branch-form>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane v-if="currentBranch && currentBranch.id > 0" label="编辑信息" name="update">
                            <div>
                                <div class="staff-info">
                                    <branch-form v-if="branchTree.length > 0" :branches-tree="branchTree" :branch-info="currentBranch" @saveCallback="saveCallback"></branch-form>
                                </div>
                            </div>
                        </el-tab-pane>
<!--                        <el-tab-pane v-if="currentBranch && currentBranch.id > 0 && currentBranch.is_business == 1" label="绑定销售地区" name="bind-area">-->
<!--                            <bind-area :branch-info="currentBranch"></bind-area>-->
<!--                        </el-tab-pane>-->
                    </el-tabs>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {BranchService, BranchModel} from "~/services/Branch";
    import BranchForm from "~/views/branch/form.vue";
    import BindArea from "~/views/branch/BindArea.vue";

    export default {
        components: {
            BranchForm,
            BindArea
        },
        data() {
            return {
                defaultProps: {
                    children: 'childs',
                    label: 'name'
                },
                parentSelected: [],
                branchForm: BranchModel,
                branchTree: [],
                currentBranch: null,
                activeName: 'create',
            };
        },
        created: function () {
            this.getBranchTreeStructure();
        },
        watch: {
            currentBranch: function(value, original) {
                if (value && value.id > 0) {
                    if (this.activeName != 'bind-area') {
                        this.activeName = 'update';
                    }
                } else {
                    // 点击顶级部门指向创建部门Tab
                    this.activeName = 'create';
                }
            },
        },
        methods: {

            getBranchTreeStructure() {
                BranchService.getTreeStructure().then(res => {
                    if (res.code == 0 && res.data) {
                        this.branchTree = res.data;
                    }
                });
            },

            handleNodeClick(data) {
                this.currentBranch = data;
            },

            saveCallback(branch) {
                this.getBranchTreeStructure();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/branch/index.vue